export const LABELS = {
	TABLE_SECTION_SR_LABEL: 'Table results'
};
